import React from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../components'

const maxLength200 = validations.maxLength(200)
const minLength10 = validations.minLength(10)

let FlashMessageForm = ({ handleSubmit, pristine, reset, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            label="Message"
            name="message"
            validate={[validations.required, minLength10, maxLength200]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col md={12} xs={12} lg={12}>
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
FlashMessageForm = reduxForm({
  form: 'flash-message-form',
})(FlashMessageForm)

export default FlashMessageForm
